/**
 * Centralized network name and icon maps for onboarding components.
 * Single source of truth to avoid duplication across step files.
 */

export const NETWORK_NAMES = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  twitter: 'X',
  x: 'X',
  google: 'Google',
  threads: 'Threads',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  bluesky: 'Bluesky',
  pinterest: 'Pinterest'
}

export const NETWORK_ICONS = {
  facebook: require('@/assets/img/iconsNetwork/ico-facebook-2x.png'),
  instagram: require('@/assets/img/iconsNetwork/ico-instagram-2x.png'),
  linkedin: require('@/assets/img/iconsNetwork/ico-linkedin-2x.png'),
  twitter: require('@/assets/img/iconsNetwork/ico-twitter-2x.png'),
  x: require('@/assets/img/iconsNetwork/ico-twitter-2x.png'),
  google: require('@/assets/img/iconsNetwork/ico-google-2x.png'),
  threads: require('@/assets/img/iconsNetwork/ico-threads-2x.png'),
  tiktok: require('@/assets/img/iconsNetwork/ico-tiktok-2x.png'),
  youtube: require('@/assets/img/iconsNetwork/ico-youtube-2x.png'),
  bluesky: require('@/assets/img/iconsNetwork/ico-bluesky-2x.png'),
  pinterest: require('@/assets/img/iconsNetwork/ico-pinterest-2x.png')
}

export function getNetworkName(network) {
  return NETWORK_NAMES[network] || ''
}

export function getNetworkIcon(network) {
  return NETWORK_ICONS[network] || ''
}
